import React, { useEffect, useState } from "react";
import "../../../../../css/pages/ca_pages/teams/employees_model/EmployeeCreate.css";

const EMPTY_FORM = {
    user_full_name: "",
    email: "",
    contact: "",
    password: "",

    employee_code: "",
    designation: "",

    office: "",
    department: "",
    team: "",
    reporting_manager: "",
};

const EmployeeCreate = ({
    isOpen,
    loading,
    error,
    options,
    onClose,
    onSubmit,
}) => {
    const [form, setForm] = useState(EMPTY_FORM);

    useEffect(() => {
        if (isOpen) {
            setForm(EMPTY_FORM);
        }
    }, [isOpen]);

    if (!isOpen) { return null; }

    const offices = options?.offices || [];
    const departments = options?.departments || [];
    const teams = options?.teams || [];
    const reportingManagers = options?.reporting_managers || [];

    const handleChange = (event) => {
        const { name, value } = event.target;

        setForm((previous) => ({ ...previous, [name]: value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const payload = {
            user_full_name: form.user_full_name,
            email: form.email,
            contact: form.contact,
            password: form.password,

            employee_code: form.employee_code,
            designation: form.designation,

            office: form.office || null,
            department: form.department || null,
            team: form.team || null,
            reporting_manager: form.reporting_manager || null,
        };

        onSubmit(payload);
    };

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(15, 23, 42, 0.45)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
                padding: "20px",
            }}
        >
            <div
                style={{
                    width: "100%",
                    maxWidth: "650px",
                    maxHeight: "90vh",
                    overflowY: "auto",
                    background: "#ffffff",
                    borderRadius: "14px",
                    padding: "24px",
                    boxShadow:
                        "0 20px 50px rgba(0,0,0,0.18)",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "24px",
                    }}
                >
                    <div>
                        <h2
                            style={{
                                margin: 0,
                                fontSize: "22px",
                                color: "#0f172a",
                            }}
                        >
                            Add Employee
                        </h2>

                        <p
                            style={{
                                margin: "6px 0 0",
                                color: "#64748b",
                                fontSize: "14px",
                            }}
                        >
                            Create a new employee for your firm.
                        </p>
                    </div>

                    <button
                        type="button"
                        onClick={onClose}
                        disabled={loading}
                        style={{
                            border: "none",
                            background: "transparent",
                            fontSize: "22px",
                            cursor: loading
                                ? "not-allowed"
                                : "pointer",
                        }}
                    >
                        ×
                    </button>
                </div>

                {error && (
                    <div
                        style={{
                            marginBottom: "18px",
                            padding: "12px 14px",
                            borderRadius: "8px",
                            background: "#fef2f2",
                            color: "#b91c1c",
                            border:
                                "1px solid #fecaca",
                        }}
                    >
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <h3
                        style={{
                            margin: "0 0 14px",
                            fontSize: "16px",
                            color: "#334155",
                        }}
                    >
                        User Details
                    </h3>

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns:
                                "1fr 1fr",
                            gap: "16px",
                        }}
                    >
                        <Field
                            label="Full Name"
                            name="user_full_name"
                            value={form.user_full_name}
                            onChange={handleChange}
                            required
                        />

                        <Field
                            label="Email"
                            name="email"
                            type="email"
                            value={form.email}
                            onChange={handleChange}
                            required
                        />

                        <Field
                            label="Contact"
                            name="contact"
                            value={form.contact}
                            onChange={handleChange}
                            required
                        />

                        <Field
                            label="Password"
                            name="password"
                            type="password"
                            value={form.password}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <h3
                        style={{
                            margin:
                                "26px 0 14px",
                            fontSize: "16px",
                            color: "#334155",
                        }}
                    >
                        Employee Details
                    </h3>

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns:
                                "1fr 1fr",
                            gap: "16px",
                        }}
                    >
                        <Field
                            label="Employee Code"
                            name="employee_code"
                            value={form.employee_code}
                            onChange={handleChange}
                            required
                        />

                        <Field
                            label="Designation"
                            name="designation"
                            value={form.designation}
                            onChange={handleChange}
                        />
                    </div>

                    <h3
                        style={{
                            margin:
                                "26px 0 14px",
                            fontSize: "16px",
                            color: "#334155",
                        }}
                    >
                        Organization Assignment
                    </h3>

                    <p
                        style={{
                            margin:
                                "0 0 16px",
                            color: "#64748b",
                            fontSize: "13px",
                        }}
                    >
                        These fields are optional and
                        can be assigned later.
                    </p>

                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns:
                                "1fr 1fr",
                            gap: "16px",
                        }}
                    >
                        <SelectField
                            label="Office"
                            name="office"
                            value={form.office}
                            onChange={handleChange}
                            options={offices}
                        />

                        <SelectField
                            label="Department"
                            name="department"
                            value={form.department}
                            onChange={handleChange}
                            options={departments}
                        />

                        <SelectField
                            label="Team"
                            name="team"
                            value={form.team}
                            onChange={handleChange}
                            options={teams}
                        />

                        <SelectField
                            label="Reporting Manager"
                            name="reporting_manager"
                            value={form.reporting_manager}
                            onChange={handleChange}
                            options={reportingManagers}
                        />
                    </div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                            marginTop: "28px",
                            paddingTop: "18px",
                            borderTop:
                                "1px solid #e2e8f0",
                        }}
                    >
                        <button
                            type="button"
                            onClick={onClose}
                            disabled={loading}
                            style={{
                                padding:
                                    "10px 18px",
                                border:
                                    "1px solid #cbd5e1",
                                background:
                                    "#ffffff",
                                borderRadius:
                                    "8px",
                                cursor:
                                    "pointer",
                            }}
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            disabled={loading}
                            style={{
                                padding:
                                    "10px 18px",
                                border: "none",
                                background:
                                    "#4f46e5",
                                color: "#ffffff",
                                borderRadius:
                                    "8px",
                                cursor:
                                    loading
                                        ? "not-allowed"
                                        : "pointer",
                                fontWeight: 600,
                            }}
                        >
                            {loading
                                ? "Creating..."
                                : "Add Employee"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

const Field = ({
    label,
    name,
    type = "text",
    value,
    onChange,
    required = false,
}) => (
    <div>
        <label
            style={{
                display: "block",
                marginBottom: "6px",
                fontSize: "13px",
                fontWeight: 600,
                color: "#334155",
            }}
        >
            {label}
            {required && (
                <span style={{ color: "#dc2626" }}>
                    {" "}*
                </span>
            )}
        </label>

        <input
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            style={{
                width: "100%",
                boxSizing: "border-box",
                padding: "10px 12px",
                border:
                    "1px solid #cbd5e1",
                borderRadius: "8px",
                outline: "none",
            }}
        />
    </div>
);

const SelectField = ({
    label,
    name,
    value,
    onChange,
    options,
}) => (
    <div>
        <label
            style={{
                display: "block",
                marginBottom: "6px",
                fontSize: "13px",
                fontWeight: 600,
                color: "#334155",
            }}
        >
            {label}
        </label>

        <select
            name={name}
            value={value}
            onChange={onChange}
            style={{
                width: "100%",
                boxSizing: "border-box",
                padding: "10px 12px",
                border:
                    "1px solid #cbd5e1",
                borderRadius: "8px",
                background: "#ffffff",
            }}
        >
            <option value="">
                Select {label}
            </option>

            {options.map((item) => {
                const id =
                    item.id ??
                    item.value;

                const labelValue =
                    item.name ??
                    item.label ??
                    item.user_full_name ??
                    item.department_name ??
                    item.office_name ??
                    item.team_name ??
                    item.email ??
                    String(id);

                return (
                    <option
                        key={id}
                        value={id}
                    >
                        {labelValue}
                    </option>
                );
            })}
        </select>
    </div>
);

export default EmployeeCreate;
